export default __webpack_public_path__ + "static/media/feature-tool_tab_3.2daafc3faafb3224a1275a2cebdf3acd.svg";